import React from 'react';
import { motion } from 'framer-motion';
import { LibraryIcon, StarIcon } from 'lucide-react';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-141" data-mp="1ivbiyxjvlvtd">
      <div className="mx-auto max-w-6xl px-4" data-id="element-142" data-mp="1it8n3ww1l8gq">
        <div className="text-center" data-id="element-143" data-mp="1dxjgj9llurax">
          <span className="inline-flex items-center gap-2 rounded-full border border-teal/25 bg-white px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-teal" data-id="element-144" data-mp="1dudts10g81id">
            <LibraryIcon className="h-4 w-4" data-id="element-145" data-mp="26lp3m304ssdx" /> Los 6 tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-146" data-mp="21l9ob5wahatb">
            Un tomo por cada dimensión de la Bibliotecología Escolar argentina
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-147" data-mp="q87ceo54x9fh">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className={`relative flex flex-col rounded-2xl bg-white p-6 text-ink shadow-card ${module.featured ? 'border-2 border-gold' : 'border border-line'}`} data-id="element-148" data-mp="1iwjufwss10v2" data-mpi={index}>
                {module.featured && <span className="absolute -top-3 left-6 inline-flex items-center gap-1 rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-wider text-petrolDark" data-id="element-149" data-mp="q7cle3vp4svk">
                    <StarIcon className="h-3 w-3 fill-current" data-id="element-150" data-mp="h5d4rcolfqt5" /> El más popular
                  </span>}
                <div className="flex items-start justify-between gap-4" data-id="element-151" data-mp="l6f6c05zgeya">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-deep text-gold" data-id="element-152" data-mp="2nunhlwjnztl7">
                    <Icon className="h-6 w-6" data-id="element-153" data-mp="2j35fv69thoz6" />
                  </span>
                  <span className="font-display text-2xl font-bold text-line" data-id="element-154" data-mp="2e4c2reyfzzzj">Tomo {module.number}</span>
                </div>
                <h3 className="mt-5 text-xl font-bold text-ink" data-id="element-155" data-mp="2960qyyol7feo">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-156" data-mp="36srd3o6mpu4j">{module.description}</p>
                <p className="mt-4 flex-1 rounded-xl border border-teal/20 bg-aquaSoft p-3 text-sm leading-relaxed text-teal" data-id="element-157" data-mp="31u6chnngt8fk">
                  <b className="font-extrabold" data-id="element-158" data-mp="2wtsfd0nejiwb">Resultado: </b>
                  {module.result}
                </p>
                <p className="mt-5 border-t border-line pt-4 text-[10px] font-extrabold uppercase tracking-[.1em] text-muted" data-id="element-159" data-mp="2ssgmmm98ehjw">
                  {module.tags}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}